// extracted by mini-css-extract-plugin
module.exports = {"detail":"index-module_detail_3RNJv","expandCt":"index-module_expandCt_3Gwgq","expandItem":"index-module_expandItem_2V1DN","expandItemFull":"index-module_expandItemFull_2Pif-"};